export const enum SnackbarEventTypes {
  USER_EVENT_PLAYING_TRACK = "USER_EVENT_PLAYING_TRACK",
  USER_EVENT_SHARED_TRACK = "USER_EVENT_SHARED_TRACK",
  USER_EVENT_SHARED_SEGMENT = "USER_EVENT_SHARED_SEGMENT",
  POINT_CONVERSATION_USER_MENTIONED = "POINT_CONVERSATION_USER_MENTIONED",
  SEGMENT_CONVERSATION_USER_MENTIONED = "SEGMENT_CONVERSATION_USER_MENTIONED",
}
